import * as React from "react";
import { forwardRef } from "react";
const SvgUiArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={6} height={5} viewBox="0 0 6 5" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M3 5 6 .5H0z" fill="currnetColor" fillRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgUiArrowDown);
export { ForwardRef as ReactComponent };